import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";

const empty = { name: "", cuit: "", address: "", phone: "", email: "", iva_condition: "", note: "" };

export default function CompanyProfile() {
  const [data, setData] = useState(empty);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/company/profile").then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const save = async () => {
    try {
      const r = await api.put("/company/profile", data);
      setData(r.data);
      toast.success("Datos de la empresa guardados");
    } catch (e) { toast.error(apiError(e)); }
  };

  if (loading) return null;

  return (
    <div data-testid="company-profile-page">
      <h1 className="font-heading font-bold uppercase text-2xl tracking-tight mb-2">Empresa</h1>
      <p className="text-neutral-500 text-sm mb-6">
        Estos datos aparecen en el encabezado de los PDF de cotización.
      </p>

      <div className="bg-[#171717] border border-neutral-800 rounded-md p-6 max-w-2xl space-y-4">
        <div>
          <label className="text-xs text-neutral-400 block mb-1">Razón social</label>
          <Input value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })}
            className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-name-input" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs text-neutral-400 block mb-1">CUIT</label>
            <Input value={data.cuit} onChange={(e) => setData({ ...data, cuit: e.target.value })}
              placeholder="20-12345678-9" className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-cuit-input" />
          </div>
          <div>
            <label className="text-xs text-neutral-400 block mb-1">Condición frente al IVA</label>
            <Input value={data.iva_condition} onChange={(e) => setData({ ...data, iva_condition: e.target.value })}
              placeholder="Responsable Inscripto" className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-iva-input" />
          </div>
        </div>
        <div>
          <label className="text-xs text-neutral-400 block mb-1">Domicilio</label>
          <Input value={data.address} onChange={(e) => setData({ ...data, address: e.target.value })}
            className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-address-input" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs text-neutral-400 block mb-1">Teléfono / WhatsApp</label>
            <Input value={data.phone} onChange={(e) => setData({ ...data, phone: e.target.value })}
              className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-phone-input" />
          </div>
          <div>
            <label className="text-xs text-neutral-400 block mb-1">Email</label>
            <Input value={data.email} onChange={(e) => setData({ ...data, email: e.target.value })}
              className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-email-input" />
          </div>
        </div>
        <div>
          <label className="text-xs text-neutral-400 block mb-1">Nota al pie (condiciones, validez, etc.)</label>
          <Textarea value={data.note} onChange={(e) => setData({ ...data, note: e.target.value })}
            className="bg-neutral-900 border-neutral-800 rounded-sm" data-testid="company-note-input" />
        </div>
        <Button onClick={save} className="w-full bg-[#F2B90D] hover:bg-[#DFA90C] text-black rounded-sm font-heading uppercase" data-testid="company-save-btn">
          Guardar
        </Button>
      </div>
    </div>
  );
}
